import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Header from '@/components/Header';
import { useTeam } from '@/contexts/TeamContext';
import { UsersThree } from '@phosphor-icons/react';

const API = `${window.location.origin}/api`;

function TeamCreate({ user }) {
  const navigate = useNavigate();
  const { fetchTeams, switchTeam } = useTeam();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const res = await axios.post(`${API}/teams`, { team_name: name.trim() }, { withCredentials: true });
      await fetchTeams();
      switchTeam(res.data);
      navigate('/team/settings');
    } catch (err) { console.error(err); }
    finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header user={user} />
      <main className="max-w-md mx-auto p-6 md:p-8 pt-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mx-auto mb-4">
              <UsersThree size={28} weight="duotone" className="text-navy" />
            </div>
            <h1 className="text-2xl font-heading font-semibold text-slate-900 mb-1">Create a Team</h1>
            <p className="text-sm text-slate-500">Set up a shared workspace for your team</p>
          </div>
          <form onSubmit={handleCreate} className="bg-white border border-slate-200 rounded-lg p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Team Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required autoFocus
                placeholder="e.g., Tunde & Partners, Amaka Chambers"
                className="bg-white border border-slate-200 rounded-lg px-4 py-3 w-full text-sm text-slate-900 focus:border-navy focus:ring-2 focus:ring-blue-100"
                data-testid="team-name-input" />
            </div>
            <button type="submit" disabled={saving || !name.trim()}
              className="w-full bg-navy text-white hover:bg-navy-hover disabled:opacity-50 font-medium px-4 py-3 rounded-lg text-sm transition-all duration-200"
              data-testid="create-team-submit">
              {saving ? 'Creating...' : 'Create Team'}
            </button>
          </form>
        </motion.div>
      </main>
    </div>
  );
}

export default TeamCreate;
